import { ArrowDownLeft, ArrowUpRight } from "lucide-react";
import React from "react";

interface CallDirectionBadgeProps {
  direction: string | null | undefined;
}

export default function CallDirectionBadge({ direction }: CallDirectionBadgeProps) {
  if (direction === "INBOUND") {
    return (
      <div className="flex items-center gap-1 text-xs">
        <ArrowDownLeft className="h-3 w-3 text-green-500" />
        Inbound
      </div>
    );
  }
  if (direction === "OUTBOUND") {
    return (
      <div className="flex items-center gap-1 text-xs">
        <ArrowUpRight className="h-3 w-3 text-blue-500" />
        Outbound
      </div>
    );
  }
  return <span className="text-muted-foreground text-xs">-</span>;
}
